import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { Observable } from 'rxjs';
import { CompanyCollectorSchemaRepository } from '@domain/company-collector-schema/repositories/company-collector-schema.repository';
import { CompanyCollectorSchemaService } from '@core/services/entities/company-collector-schema.service';
import { ListCompanyCollectorSchemaRequestDto } from '@domain/company-collector-schema/dtos/list-company-collector-schema-request.dto';
import { GetCompanyCollectorSchemaRequestDto } from '@domain/company-collector-schema/dtos/get-company-collector-schema-request.dto';
import { CompanyCollectorSchemaResponseDto } from '@domain/company-collector-schema/dtos/company-collector-schema-response.dto';
import { PageableResponse } from '@core/interface/pageable.interface';
import { CreateCompanyCollectorSchemaRequestDto } from '@domain/company-collector-schema/dtos/create-company-collector-schema-request.dto';
import { UpdateCompanyCollectorSchemaRequestDto } from '@domain/company-collector-schema/dtos/update-company-collector-schema-request.dto';
import { RefId } from '@core/interface/ref-id.interface';

@Injectable({
  providedIn: 'root',
})
export class CompanyCollectorSchemaRepositoryService implements CompanyCollectorSchemaRepository {
  constructor(
    private companyCollectorSchemaService: CompanyCollectorSchemaService,
  ) {}

  list(
    request: ListCompanyCollectorSchemaRequestDto,
  ): Observable<
    ApiResponse<PageableResponse<CompanyCollectorSchemaResponseDto>>
  > {
    return this.companyCollectorSchemaService.list(request);
  }

  get(
    request: GetCompanyCollectorSchemaRequestDto,
  ): Observable<ApiResponse<CompanyCollectorSchemaResponseDto[]>> {
    return this.companyCollectorSchemaService.get(request);
  }

  create(
    request: CreateCompanyCollectorSchemaRequestDto,
  ): Observable<ApiResponse<CompanyCollectorSchemaResponseDto>> {
    return this.companyCollectorSchemaService.create(request);
  }

  update(
    refId: string,
    request: UpdateCompanyCollectorSchemaRequestDto,
  ): Observable<ApiResponse<CompanyCollectorSchemaResponseDto>> {
    return this.companyCollectorSchemaService.update(refId, request);
  }

  updateState(
    refId: string,
    state: string,
  ): Observable<ApiResponse<CompanyCollectorSchemaResponseDto>> {
    return this.companyCollectorSchemaService.updateState(refId, state);
  }

  delete(
    request: RefId,
  ): Observable<ApiResponse<CompanyCollectorSchemaResponseDto>> {
    return this.companyCollectorSchemaService.delete(request);
  }

  show(
    refId: string,
  ): Observable<ApiResponse<CompanyCollectorSchemaResponseDto>> {
    return this.companyCollectorSchemaService.show(refId);
  }
}
